/** HTML tags that count as visible content even with no text (embedded media). */
const MEDIA_TAG = /<(img|svg|video|canvas|iframe|table)\b/i;

/**
 * Whether a document's preview markup has anything worth rendering. An empty
 * document carries a non-null but structurally-empty markup (e.g. `<p></p>`,
 * `<p><br></p>`) — that should be treated as "no preview" so the card shows the
 * empty-state illustration instead of a blank MarkupPreview.
 *
 * Content = any non-whitespace text once tags are stripped, OR any embedded
 * media tag (an image-only doc still has a preview).
 */
export function hasPreviewContent(markup: string | null | undefined): markup is string {
  if (!markup) return false;
  if (MEDIA_TAG.test(markup)) return true;
  const text = markup
    .replace(/<[^>]*>/g, '') // strip tags
    .replace(/&nbsp;/g, ' ')
    .trim();
  return text.length > 0;
}
